import React from 'react';

export const LagoonContext = React.createContext();
